export const API_DEFAULT_REQUESTS_PER_SECOND = 30;
export const API_SHOPIFY_REQUESTS_PER_SECOND = 300;

export const IMPACT_ORDER_SUPPORTED_FROM_YEAR = 2023;

export const ECOLOGI_VAT_ID = '417960184';
export const ECOLOGI_REGISTRATION_NUMBER = '11911630';

export const getClientApiProxyUrl = (baseUrl: string, path: string) => `${baseUrl}/api/proxy${path}`;
